<template>
    <vue-multiselect
        :model-value="selected"
        :options="selectOptions"
        :show-labels="false"
        :searchable="false"
        label="label"
        track-by="code"
        @update:model-value="onSelected"
        :allow-empty="false"
        class="rounded-sm border border-gray-light font-sans text-[16px] multiselect--with-images"
        :option-height="350"
    >
        <template #singleLabel="props">
            <div class="flex flex-col w-full h-full text-[16px]">
                <div>
                    <span>{{ props.option.label }}</span>&nbsp;
                    <span
                        v-if="props.option.price"
                        class="text-red"
                    >
                        ({{props.option.price}})
                    </span>
                </div>
            </div>
        </template>

        <template #option="props">
            <div class="flex flex-col w-full justify-around text-[16px] h-[84px] px-[16px] py-[16px]">
                <div>
                    <span>{{ props.option.label }}</span>&nbsp;
                    <span
                        v-if="props.option.price"
                        class="text-red"
                    >
                        ({{props.option.price}})
                    </span>
                </div>
                <div class="flex">
                    <img
                        :src="getImage(props.option.raw)"
                        v-if="getImage(props.option.raw)"
                    />
                </div>
            </div>
        </template>
    </vue-multiselect>
</template>

<script>
    import VueMultiselect from 'vue-multiselect';
    import 'vue-multiselect/dist/vue-multiselect.css';
    import getImage from '../helpers/getimage';
    import allStores from '../stores/all';

    export default {
        components: {
            VueMultiselect,
        },

        mixins: [allStores],

        emits: ['input'],

        data: () => ({
            image: null,
        }),

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            selected() {
                return this.selectOptions.find((x) => x.selected);
            },
        },

        props: {
            selectOptions: {
                type: Array,
                required: true,
            },
        },

        mounted() {
            this.image = this.selectOptions.find((x) => x.selected)?.image;
        },

        methods: {
            onSelected(v) {
                this.$emit('input', v);
            },

            getImage(option) {
                return getImage(this.viewController, option);
            },
        },
    };
</script>

<style lang="scss">
    #cz3 {
        .multiselect,
        .multiselect__tags {
            @apply text-black;
            min-height: 46px;
        }

        .multiselect__single,
        .multiselect__placeholder {
            font-size: 16px;
            @apply m-0;
        }

        .multiselect__select {
            @apply h-full;
            &::before {
                border-width: 5px 5px 0 5px;
                border-color: black transparent transparent transparent;
            }
        }

        .multiselect__element {
            font-size: 16px;
        }

        .multiselect__tags {
            @apply pt-0 flex items-center;
        }

        .multiselect__option {
            @apply px-2 flex items-center font-sans;
        }

        .multiselect__option--highlight {
            @apply bg-ink;
        }

        .multiselect--with-images {
            .multiselect__element + .multiselect__element {
                border-top: 1px solid #dfdfdf;
            }
        }
    }
</style>
